<template>
    <el-radio-group v-model="data">
        <template v-for="(item, index) in list">
            <el-radio v-if="item[label]" :label="item[value]" :border="border" >{{item[label]}}</el-radio>
            <el-radio v-else :label="index">{{item}}</el-radio>
        </template>
    </el-radio-group>
</template>

<script>
export default {
  name: 'MyRadioGroup',
  model: {
    prop: 'radio', // 要存在于proops
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    radio: { // 默认值
      type: [String, Number, Boolean],
    },
    label: {
      type: String,
      default: 'label'
    },
    value: {
      type: String,
      default: 'value'
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    border: {   //边框
      type: Boolean,
      default: false
    }   
  },
  data() {
    return {
      data: this.radio
    };
  },

  watch: { // 这里检测data中的值，一旦发生变化就提交事件到父组件
    data: {
      handler(newVal) {
        this.$emit('change', newVal);
      },
      deep: true
    },
    radio(val) {
      this.data = val;
    }
  }
};
</script>